import React from "react";
// 直接具体路径，不走 components barrel，否则会形成 components ↔ 本文件 的自环
import { Dialog } from "../Base/Dialog";
import { useT } from "../../i18n/hooks";
import type { PasswordRecoveryDialogProps } from "./PasswordRecoveryDialog.types";
import "./PasswordRecoveryDialog.scss";

const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="56"
    viewBox="0 0 57 56"
    fill="none"
    className="password-recovery-dialog__option-icon"
  >
    <path
      d="M12.5 5.14287C12.5 3.03893 14.2056 1.33334 16.3095 1.33334H40.4365C42.5404 1.33334 44.246 3.03893 44.246 5.14287V50.8572C44.246 52.9611 42.5404 54.6667 40.4365 54.6667H16.3095C14.2056 54.6667 12.5 52.9611 12.5 50.8572V5.14287Z"
      fill="url(#paint0_linear_phone)"
    />
    <path
      d="M15.6746 8.65082C15.6746 8.30016 15.9588 8.0159 16.3095 8.0159H40.4365C40.7871 8.0159 41.0714 8.30016 41.0714 8.65082V44.8413C41.0714 45.1919 40.7871 45.4762 40.4365 45.4762H16.3095C15.9588 45.4762 15.6746 45.1919 15.6746 44.8413V8.65082Z"
      className="password-recovery-dialog__svg-screen"
    />
    <path
      d="M25.1985 4.84125C25.1985 4.49059 25.4827 4.20633 25.8334 4.20633H30.9128C31.2634 4.20633 31.5477 4.49059 31.5477 4.84125C31.5477 5.19191 31.2634 5.47617 30.9128 5.47617H25.8334C25.4828 5.47617 25.1985 5.19191 25.1985 4.84125Z"
      className="password-recovery-dialog__svg-screen"
    />
    <path
      d="M30.9129 50.07C30.9129 51.4726 29.7758 52.6097 28.3732 52.6097C26.9706 52.6097 25.8335 51.4726 25.8335 50.07C25.8335 48.6674 26.9706 47.5303 28.3732 47.5303C29.7758 47.5303 30.9129 48.6674 30.9129 50.07Z"
      className="password-recovery-dialog__svg-screen"
    />
    <defs>
      <linearGradient
        id="paint0_linear_phone"
        x1="28.373"
        y1="54.6667"
        x2="28.373"
        y2="1.33334"
        gradientUnits="userSpaceOnUse"
      >
        <stop className="password-recovery-dialog__svg-grad-start" />
        <stop offset="1" className="password-recovery-dialog__svg-grad-end" />
      </linearGradient>
    </defs>
  </svg>
);

const EmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
    className="password-recovery-dialog__option-icon"
  >
    <path
      d="M51.667 41.2666C51.667 43.4756 49.8759 45.2663 47.667 45.2666H9C6.79086 45.2666 5 43.4757 5 41.2666V21.4668L26.5439 32.2392C27.67 32.8023 28.996 32.8022 30.1221 32.2392L51.667 21.4668V41.2666Z"
      fill="url(#paint0_linear_email)"
    />
    <path
      d="M5 14.6667C5 12.4575 6.79086 10.6667 9 10.6667H47.6666C49.8757 10.6667 51.6666 12.4575 51.6666 14.6667V18.6001L30.1222 29.3724C28.996 29.9355 27.6705 29.9355 26.5444 29.3724L5 18.6001V14.6667Z"
      fill="url(#paint1_linear_email)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_email"
        x1="28.3335"
        y1="45.2666"
        x2="28.3335"
        y2="21.4668"
        gradientUnits="userSpaceOnUse"
      >
        <stop className="password-recovery-dialog__svg-grad-start" />
        <stop offset="1" className="password-recovery-dialog__svg-grad-end" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_email"
        x1="28.3333"
        y1="30.2669"
        x2="28.3333"
        y2="10.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop className="password-recovery-dialog__svg-grad-start" />
        <stop offset="1" className="password-recovery-dialog__svg-grad-end" />
      </linearGradient>
    </defs>
  </svg>
);

export const PasswordRecoveryDialog: React.FC<PasswordRecoveryDialogProps> = ({
  visible,
  onClose,
  onSelectMethod,
}) => {
  const t = useT();

  return (
    <Dialog
      visible={visible}
      onClose={onClose}
      className="password-recovery-dialog"
      showCloseButton={true}
      closeButtonPosition="bottom-center"
    >
      <div className="password-recovery-dialog__title">
        {t("auth.passwordRecovery")}
      </div>
      <div className="password-recovery-dialog__options">
        <button
          type="button"
          className="password-recovery-dialog__option"
          onClick={() => onSelectMethod("phone")}
        >
          <div className="password-recovery-dialog__option-icon-box">
            <div className="password-recovery-dialog__option-icon-wrap">
              <PhoneIcon />
            </div>
          </div>
          <span className="password-recovery-dialog__option-label">
            {t("auth.phone")}
          </span>
        </button>
        <button
          type="button"
          className="password-recovery-dialog__option"
          onClick={() => onSelectMethod("email")}
        >
          <div className="password-recovery-dialog__option-icon-box">
            <div className="password-recovery-dialog__option-icon-wrap">
              <EmailIcon />
            </div>
          </div>
          <span className="password-recovery-dialog__option-label">
            {t("auth.passwordRecoveryEmail")}
          </span>
        </button>
      </div>
    </Dialog>
  );
};
